import React from 'react';
// import PropTypes from 'prop-types';
import Helmet from 'react-helmet'
import Header from './header'
import Footer from './footer'
import '../styles/style.css'
import '../styles/theme-1.css'
import '../styles/bootstrap.min.css'
import '../styles/fontAwesome/css/font-awesome.min.css'
import '../styles/simple-line-icons/css/simple-line-icons.css'


const propTypes = {};

const defaultProps = {};

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <main>
        <Helmet>
        <title>TV Measurement | Media Simulator | Tv Optimizer </title>
        <meta name="description" content="Sharpen your marketing with Adorithm by using tv measurement,media simulator and tv optimizer" />
          {/* <!-- Global site tag (gtag.js) - Google Analytics --> */}
          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-140607553-1"></script>
          <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'UA-140607553-1');
          `}</script>
          <script type='application/ld+json' >{`
         {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "@id": "https://adorithm.ai/#organization",
              "name": "Adorithm",
              "url": "https://adorithm.ai/",
              "logo": {
                "@type": "ImageObject",
                "@id": "https://adorithm.ai/#logo",
                "url": "https://adorithm.ai/static/logo_white-d5808a89e30c5ab04fcf16e7807f9571.png",
                "width": 140,
                "height": 25,
                "caption": "Adorithm"
              },
              "image": {
                "@id": "https://adorithm.ai/#logo"
              }
            },
            {
              "@type": "WebSite",
              "@id": "https://adorithm.ai/#website",
              "url": "https://adorithm.ai/",
              "name": "TV Measurement - Adorithm",
              "publisher": {
                "@id": "https://adorithm.ai/"
              },
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://adorithm.ai/?s={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            },
            {
              "@type": "ImageObject",
              "@id": "https://adorithm.ai/#primaryimage",
              "url": "https://adorithm.ai/static/logo_white-d5808a89e30c5ab04fcf16e7807f9571.png",
              "width": 140,
              "height": 25,
              "caption": "Media simulator"
            },
            {
              "@type": "WebPage",
              "@id": "https://adorithm.ai/#webpage",
              "url": "https://adorithm.ai/",
              "inLanguage": "en-US",
              "name": "Adorithm: Leading TV Measurement and leading Media Simulator",
              "isPartOf": {
                "@id": "https://adorithm.ai/#website"
              },
              "about": {
                "@id": "https://adorithm.ai/#organization"
              },
              "primaryImageOfPage": {
                "@id": "https://adorithm.ai/#primaryimage"
              },
              "datePublished": "2019-07-11T09:14:50+00:00",
              "dateModified": "2019-08-09T15:07:49+00:00",
              "description": "Sharpen your marketing with Adorithm’s AI-Driven and expert-curated business insights."
            }
          ]
         }
          `}</script>
        </Helmet>
        <Header />
        {this.props.children}
        <Footer />
      </main>
    );
  }
}

 Layout.propTypes = propTypes;
 Layout.defaultProps = defaultProps;
